import Wizard from './Wizard';
import WizardButtons from './WizardButtons';
import WizardError from './WizardError';
import WizardHeader from './WizardHeader';
import WizardProgress from './WizardProgress';
import WizardStep from './WizardStep';
import WizardSuccess from './WizardSuccess';

export {
    WizardButtons,
    WizardError,
    WizardHeader,
    WizardProgress,
    WizardStep,
    WizardSuccess
};

export default Wizard;
